<template>
  <div class="registeredPage">
    <div class="title">注册</div>
    <div class="tabContent">
      <div
        v-for="(item, index) in navList"
        :key="index"
        :class="[
          item.isOk ? 'navActiveColor' : '',
          item.type == navType ? 'navActiveBg' : '',
        ]"
      >
        <!-- @click="navClick(item)" -->
        <img src="@/assets/images/radioIconActive.png" v-if="item.isOk" />
        {{ item.name }}
      </div>
    </div>
    <accountRegistration v-show="navType == 1" @isOk="isOk" />
    <chooseType v-show="navType == 2" @chooseType="chooseType" @isOk="isOk" />
    <personalRegistrationInformation
      v-show="navType == 3"
      :personalType="personalType"
      @isOk="isOk"
    />
    <enterpriseEntryInformation
      v-show="navType == 4"
      :enterpriseType="enterpriseType"
      @isOk="isOk"
    />
    <div class="btnwap">
      <div class="btnContent">
        <!-- <div v-if="navType == 1">
          <router-link to="/login"> 登录 </router-link>
        </div> -->
        <div
          v-if="navType == 2 || navType == 3 || navType == 4"
          @click="backMth"
        >
          上一步
        </div>
        <div
          v-if="navType == 1 && navList[0].isOk"
          @click="navType = navType + 1"
        >
          下一步
        </div>
        <div v-if="navType == 3 || navType == 4" @click="submit()">提交</div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";

import accountRegistration from "@/components/registered/accountRegistration";
import chooseType from "@/components/registered/chooseType";
import personalRegistrationInformation from "@/components/registered/personalRegistrationInformation";
import enterpriseEntryInformation from "@/components/registered/enterpriseEntryInformation";

export default {
  name: "registeredPage",
  data() {
    return {
      personalType: null,
      enterpriseType: null,
      num: 0,
      navType: 1,
      navList: [
        {
          name: "1.账号注册",
          type: 1,
          isOk: false,
        },
        {
          name: "2.选择类型",
          type: 2,
          isOk: false,
        },
        {
          name: "3.入驻资料",
          type: 3,
          isOk: false,
        },
      ],
    };
  },
  methods: {
    submit() {
      let { navType } = this;
      navType == 3
        ? (this.personalType = this.num++)
        : (this.enterpriseType = this.num++);
    },
    isOk(e) {
      let { key, isOk } = e;
      this.navList[key - 1].isOk = isOk;
      this.navType = this.navType + 1;
    },
    chooseType(e) {
      this.navType = e;
    },
    backMth() {
      if (this.navType == 3 || this.navType == 4) {
        this.navType = 2;
      } else {
        this.navType = this.navType - 1;
      }
    }
  },
  components: {
    accountRegistration,
    chooseType,
    personalRegistrationInformation,
    enterpriseEntryInformation,
  },
  created() {
    if (Cookies.get("userInformation") && !this.$route.query.type) {
      this.navList[0].isOk = true;
      this.navType = 2;
    }
  },
};
</script>
<style lang="scss" scoped>
.registeredPage {
  display: flex;
  flex-direction: column;
  align-items: center;
  .btnwap {
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 40px 0;
    .btnContent {
      width: 432px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      div {
        text-align: center;
        border-radius: 8px;
        height: 40px;
        font-size: 14px;
        font-family: AlibabaPuHuiTiM;
        line-height: 40px;
        cursor: pointer;
      }
      div:nth-of-type(1) {
        width: 120px;
        color: #909399;
        text-align: center;
        background: #fff;
        border: 1px solid #c0c4cc;
        a {
          color: #909399 !important;
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      div:nth-of-type(2) {
        width: 240px;
        color: #ffffff;
        background: #008aea;
      }
    }
  }
  .title {
    margin: 80px 0 40px 0;
    width: 100%;
    text-align: center;
    font-size: 30px;
    font-family: AlibabaPuHuiTiB;
    color: #303133;
  }
  .tabContent {
    width: 100%;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f5f7fa;
    box-shadow: 0px 0px 0px 0px #e6e6e6;
    margin-bottom: 56px;
    div {
      width: 160px;
      height: 48px;
      font-size: 14px;
      font-family: AlibabaPuHuiTiM;
      color: #909399;
      line-height: 48px;
      text-align: center;
      font-weight: 700;
      // cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 24px;
      }
    }
    .navActiveColor {
      color: #008aea;
    }
    .navActiveBg {
      background: #fff;
    }
  }
}
</style>
